import { capitalize } from 'helpers/helpers';
import { camelize } from 'helpers/syntaxHelper';
import { translateBlock } from 'i18n';
import React from 'react';
import { getFilterDisplay } from './helpers';
import {
    StyFilter,
    StyFilterContent,
    StyFilterLegend,
    StyTypography,
} from './SharedStyledComponents';

export type FilterItemProps = {
    filter: DashboardFilterT & WithScopes;
};

const FilterItemDisplay = ({ filter }: FilterItemProps) => {
    const filterTitle = capitalize(translateBlock(camelize(filter.field)));
    const FilterDisplay = getFilterDisplay(filter);

    return (
        <StyFilter>
            <StyFilterLegend hidden={!filter.value}>
                <StyTypography>{filter.value && filterTitle}</StyTypography>
            </StyFilterLegend>

            <StyFilterContent>
                <FilterDisplay filter={filter} />
            </StyFilterContent>
        </StyFilter>
    );
};

export default FilterItemDisplay;
